module.exports = __webpack_public_path__ + "static/media/signage-indoor-img83.7f8767a7.jpg";